import axios from "axios";
import { userState } from "@/utils/store";

if (!process.env.VUE_APP_BASE_URL) {
  throw new Error("Backend URL not defined");
}

const baseURL = process.env.VUE_APP_BASE_URL + "/api";

console.log("Backend: %s", baseURL);

const api = axios.create({
  baseURL: baseURL,
  withCredentials: true,
});

function setInterceptors() {
  api.interceptors.response.use(
    (response) => response,

    async (error) => {
      if (!error.response) {
        console.log("No response from server");
        return Promise.reject(error);
      }

      const status = error.response.status;
      const requestUrl = error.config.url;

      // 🚫 1 — PAS DE REFRESH POUR LES ROUTES PUBLIQUES !
      const publicEndpoints = [
        "auth/signup/",
        "auth/check-password/",
        "auth/token/",
      ];

      if (publicEndpoints.some((ep) => requestUrl.includes(ep))) {
        return Promise.reject(error);
      }

      // 🚫 2 — SI PAS CONNECTÉ, NE PAS ESSAYER DE REFRESH !
      if (!userState.refresh) {
        return Promise.reject(error);
      }

      // 🔥 3 — Gestion du 401 avec refresh SI token existe
      if (status === 401) {
        console.log("401 intercepted on:", requestUrl);

        // Si c'est une erreur sur le refresh token, on logout
        if (requestUrl.includes("auth/token/refresh/")) {
          console.log("Refresh token expired → logout");
          userState.logout();
          return Promise.reject(error);
        }

        // Empêcher boucle infinie
        if (error.config._retry) {
          return Promise.reject(error);
        }
        error.config._retry = true;

        try {
          const newAccessToken = await userState.refreshAccessToken();

          console.log("New access token:", newAccessToken);

          error.config.headers["Authorization"] = `Bearer ${newAccessToken}`;

          return api(error.config);
        } catch (refreshError) {
          userState.logout();
          return Promise.reject(error);
        }
      }

      return Promise.reject(error);
    }
  );
}

export { api, setInterceptors };
